import type { ComponentProps } from "react"

import { Button } from "@be-miniapp/ui/components/ui/button"

export interface NavigateHomeButtonProps
  extends Omit<ComponentProps<typeof Button>, "onClick"> {
  homePath?: string
  partnerIdentifier?: string | null
}

export function resolveNavigateHomePartnerIdentifier(options: {
  currentUrl: URL
  partnerIdentifier?: string | null
  storage?: Pick<Storage, "getItem"> | null
}): string | undefined {
  const { currentUrl, partnerIdentifier, storage } = options

  return (
    partnerIdentifier ||
    currentUrl.searchParams.get("ptr") ||
    currentUrl.searchParams.get("partner_identifier") ||
    storage?.getItem("partner_identifier") ||
    undefined
  )
}

export function buildNavigateHomeUrl(options: {
  currentHref: string
  homePath?: string
  partnerIdentifier?: string | null
  storage?: Pick<Storage, "getItem"> | null
}): string {
  const {
    currentHref,
    homePath = "/ride/home",
    partnerIdentifier,
    storage,
  } = options

  const currentUrl = new URL(currentHref)
  const targetUrl = new URL(homePath, currentUrl.origin)
  const resolvedPartnerIdentifier = resolveNavigateHomePartnerIdentifier({
    currentUrl,
    partnerIdentifier,
    storage,
  })

  targetUrl.searchParams.set("persisted", "true")

  if (resolvedPartnerIdentifier) {
    targetUrl.searchParams.set("ptr", resolvedPartnerIdentifier)
  }

  return targetUrl.toString()
}

export function NavigateHomeButton(props: NavigateHomeButtonProps) {
  const {
    homePath = "/ride/home",
    partnerIdentifier,
    className = "h-8",
    children = "Về trang chủ",
    ...buttonProps
  } = props

  return (
    <Button
      {...buttonProps}
      onClick={() => {
        const newUrl = buildNavigateHomeUrl({
          currentHref: window.location.href,
          homePath,
          partnerIdentifier,
          storage: window.localStorage,
        })
        window.location.href = newUrl
      }}
      className={className}
    >
      {children}
    </Button>
  )
}
